import { supabase } from '../../lib/supabase';
import { handleSupabaseError, isPostgrestError } from '../../utils/errorHandling';

export type UserBasicInfo = {
  id: string;
  username: string;
  role: string;
  email: string;
  // Active status is determined by deleted_at being null
  deleted_at: string | null;
};

/**
 * Fetches a list of all active users in the system
 * Used primarily for administrative functions
 */
export async function fetchAllActiveUsers(): Promise<UserBasicInfo[]> {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select(`
        id,
        username,
        role,
        email,
        deleted_at
      `)
      .is('deleted_at', null) // Only get active users (not soft-deleted)
      .order('username');

    if (error) {
      throw isPostgrestError(error) ? handleSupabaseError(error) : error;
    }

    console.log('Fetched users:', data); // Debug log
    return (data || []) as UserBasicInfo[];
  } catch (error) {
    console.error('Error fetching active users:', error);
    throw error;
  }
}

